import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { useAuthStore } from '@/stores/useAuthStore';

export function NoAccessPage() {
  const logout = useAuthStore((s) => s.logout);

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-4">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle>관리자 권한이 없습니다</CardTitle>
        </CardHeader>
        <CardContent className="flex flex-col gap-4">
          <p className="text-sm text-muted-foreground">
            이 콘솔은 온토 staff/superadmin 또는 조직 관리자만 사용할 수 있습니다.
            일반 사용자는 ontoh 포털을 이용하세요.
          </p>
          <div className="flex gap-2">
            <Button asChild variant="outline">
              <a href="http://localhost:5173">ontoh 포털로 이동</a>
            </Button>
            <Button
              variant="ghost"
              onClick={async () => {
                await logout();
                window.location.href = '/login';
              }}
            >
              로그아웃
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
